<div class="upsell-mbg p-1 py-8">
  <div class="upsell-mbg__container mx-auto w-full p-8 desktop:p-12">
    <div class="desktop:flex gap-8 items-start">
      <img class="mx-auto w-52 shrink-0 self-start mb-4" [src]="mbgBadgeLink"> 
      <div class="upsell-mbg__text text-22" [innerHTML]="displayMbgText"></div>
    </div>

    <div *ngIf="mbgCTA" class="desktop:flex text-center flex-col items-center">
      <button 
        data-qa="cta-yes" 
        class="upsell-mbg__button-yes text-xl py-2.5 px-4 mb-4 rounded-full text-white font-bold leading-tight desktop:w-fit"
        (click)="nextPage(true)" 
        data-te="cta-yes" 
        [innerHTML]="buttonYesText">
      </button>

      <button 
        data-qa="cta-no" 
        class="upsell-mbg__button-no text-xl py-2.5 px-4 rounded-full leading-tight desktop:w-fit"
        (click)="nextPage(false)" 
        [innerHTML]="buttonNoText" 
        data-te="cta-no">
      </button>
    </div>
  </div>
</div>
